












































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Gallery extends Vue {
  private photos = [
    {
      name: '1',
      description: 'We met',
    },
    {
      name: '2',
      description: 'We fell in love...with lobster rolls',
    },
    {
      name: '3',
      description: 'and with baseball',
    },
    {
      name: '4',
      description: 'He proposed..she said yes!',
    },
    {
      name: '5',
      description: 'Our engagement',
    },
    {
      name: '6',
      description: 'Our mahar',
    },
  ];
}
